/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';



import { Configuration }                                     from '../configuration';



export interface HomeServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * loads the homepage
     * loads the homepage
     */
    loadIndex(extraHttpRequestParams?: any): Observable<string>;

}
